var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTournamentsArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5702_267)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5702_267",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(180 24.5 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5702_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7 12L9.80001 8.09995C9.61668 7.91662 9.52501 7.68329 9.52501 7.39995C9.52501 7.11662 9.61668 6.88329 9.80001 6.69995C9.98334 6.51662 10.2167 6.42495 10.5 6.42495C10.7833 6.42495 11.0167 6.51662 11.2 6.69995L15.8 11.3C15.9 11.4 15.9708 11.5083 16.0125 11.625C16.0542 11.7416 16.075 11.8666 16.075 12C16.075 12.1333 16.0542 12.2583 16.0125 12.375C15.9708 12.4916 15.9 12.6 15.8 12.7L11.2 17.3C11.0167 17.4833 10.7833 17.575 10.5 17.575C10.2167 17.575 9.98335 17.4833 9.80001 17.3C9.61668 17.1166 9.52501 16.8833 9.52501 16.6C9.52501 16.3166 9.61668 16.0833 9.80001 15.9L13.7 12Z",
    fill: "#FAF9F8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5702_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24.5 24) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentsArrowRight);
export default __webpack_public_path__ + "static/media/tournaments-arrow-right.7ea1f95227d808cb863d84c73f6f7dc0.svg";
export { ForwardRef as ReactComponent };